import script from "./TaxExpendituresList.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxExpendituresList.vue?vue&type=script&setup=true&lang=js"

import "./TaxExpendituresList.vue?vue&type=style&index=0&id=4eec55a3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eec55a3"]])

export default __exports__